import { IconWrapper } from '../runtime';
export default IconWrapper('company-default-logo', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 36 36",
      "fill": "none"
    }
  }, [h("g", {
    "attrs": {
      "clip-path": 'url(#' + props.id + 'c4314617' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18Z",
      "fill": "#0A6CFF"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M18 10.623C18 9.86948 17.2147 9.3732 16.5342 9.69659L10.6586 12.4886C10.2563 12.6797 10 13.0854 10 13.5308V24.2308C10 24.6556 10.3444 25 10.7692 25H18V24.9996H20V25H25.2308C25.6556 25 26 24.6556 26 24.2308V15.8158C26 15.318 25.6807 14.8763 25.208 14.7202L20.5052 13.1669C20.2564 13.0847 20 13.27 20 13.5321V21.9083V22C20 22.5523 19.5523 23 19 23C18.4477 23 18 22.5523 18 22V21.9083V10.623Z",
      "fill": "white"
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": props.id + 'c4314617'
    }
  }, [h("rect", {
    "attrs": {
      "width": "36",
      "height": "36",
      "rx": "18",
      "fill": "white"
    }
  })])])]);
});